import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=5d447c18&"
import script from "./AddShop.vue?vue&type=script&lang=js&"
export * from "./AddShop.vue?vue&type=script&lang=js&"
import style0 from "./AddShop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports